module.exports = __webpack_public_path__ + "static/media/analytics-module.bbbdc45b.svg";